  //SearchSlice.js

import { createSlice } from '@reduxjs/toolkit'
import { fetchSearchSuggestions, fetchGreetingFromGraphQL } from '../thunks/searchThunk'
import { logout } from './UserAuthSlice'
import { resetOtherStateAfterLogin } from './UserAuthSlice'

const initialState = {
  searchTerm: '',
  searchSuggestions: [], //array of obj [{name: "Asaa"}]
  searchedApp:'', //app name that a user wants to search e.g. "Meta" etc
  isLoading: false
}

const SearchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    changeSearchTerm: (state, action) => {

      state.searchTerm = action.payload
      //state.searchSuggestions.push(action.payload) //temp
    },
    selectSearchSuggestion: (state, action) => {
      state.searchTerm = action.payload,
      state.searchSuggestions =[] //reset the suggestion array so that suggestion list closes
    },
    updateSearchedApp: (state, action) => {
      state.searchedApp = action.payload
    }

  },
  extraReducers(builder){
    //coming from graphQL - greetings API
    builder.addCase(fetchGreetingFromGraphQL.fulfilled, (state, action) => {
        //console.log(action.payload.data.greeting)
       state.searchSuggestions.push(action.payload.data.greeting) //updating the suggestionlist
    });
    //coming from graphQL
    builder.addCase(fetchSearchSuggestions.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchSearchSuggestions.fulfilled, (state, action) => {
        //console.log(action.payload.data)
       state.searchSuggestions =action.payload.data.searchWebApps.concat(action.payload.data.searchiOSApps) //updating the suggestionlist
       state.isLoading = false;
    });
    builder.addCase(logout, (state, action) => {
      //console.log("logout")
      return initialState
    })
    builder.addCase(resetOtherStateAfterLogin, (state, action) => {
      //console.log("resetOtherStateAfterLogin")
      return initialState
    })

  }
})

// Action creators are generated for each case reducer function
export const { changeSearchTerm, selectSearchSuggestion } = SearchSlice.actions

export const searchReducer = SearchSlice.reducer;